import { Validation } from '../../../../../interfaces/common';
import { NoteForm } from '../../../../../interfaces/payout.interface';
import { APP_ERROR_MESSAGES, VALIDATION_FIELD_MAPPING } from '../../../../../utils/appConstant';

export const validateNoteForm = (formData: NoteForm, fieldToValidate?: string): Validation => {
  const validations: Validation = { validate: true, fields: [] };

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.action) {
    if (!formData.action) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.action,
        message: APP_ERROR_MESSAGES.reconciliation.payout.blankAction,
      });
    }
  }

  // if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.notes) {
  //   if (!formData.notes || formData.notes.trim() === '') {
  //     validations.validate = false;
  //     validations.fields.push({
  //       field: VALIDATION_FIELD_MAPPING.notes,
  //       message: APP_ERROR_MESSAGES.reconciliation.payout.blankNotes,
  //     });
  //   }
  // }

  return validations;
};
